export const LOGIN_ENDPOINT = 'token';
export const GET_STATUS_ENDPOINT = 'api/userManagement/getStatus';
